<template>
<div class="tabbar">
    <file-type-chose ref="ctype" @download="download"></file-type-chose>
    <div class="icon"><img src="../assets/image/tabbar/icon.png" v-if="!hideDazeElement" /><span v-else class="logo-text">抠图</span></div>
    <div class="opera" :class="{'init':init}">
        <el-tooltip effect="dark" content="放大" placement="bottom">
            <i class="tool iconfont icon-big" @click="tool('zoomin')"></i>
        </el-tooltip>
        <div class="zoom-num">{{zoom}}%</div>
        <el-tooltip effect="dark" content="缩小" placement="bottom">
            <i class="tool iconfont icon-small" @click="tool('zoomout')"></i>
        </el-tooltip>
        <el-tooltip effect="dark" content="图片复位" placement="bottom">
            <i class="tool iconfont icon-tupianfuwei" @click="tool('reset')"></i>
        </el-tooltip>
        <el-tooltip effect="dark" content="移动(Ctrl+拖动)" placement="bottom">
            <i class="tool iconfont icon-pan" @click="tool('pan')" :class="{'panactived':panactived}"></i>
        </el-tooltip>
        <el-tooltip effect="dark" content="撤销(Ctrl+Z)" placement="bottom">
            <i class="tool iconfont icon-back" @click="tool('back')" :class="backstatus"></i>
        </el-tooltip>
        <el-tooltip effect="dark" content="恢复(Ctrl+Y)" placement="bottom">
            <i class="tool iconfont icon-forward" @click="tool('forward')" :class="forwardstatus"></i>
        </el-tooltip>
        <el-tooltip effect="dark" content="重做(Ctrl+Shift+Z)" placement="bottom">
            <i class="tool iconfont icon-redo" @click="tool('redo')"></i>
        </el-tooltip>
    </div>
    <div class="other-oprea">
        <div class="help" @click="opentotalhelp" v-if="!hideDazeElement">
            <i class="tool iconfont icon-question"></i>
            如何抠图
        </div>
        <div class="btn upload" id="uploadbtn" v-if="!isplugin">上传图片</div>
        <div class="btn download" v-if="!isplugin && drawflag" @click="$refs.ctype.showNow()"> 下载</div>
        <el-tooltip effect="dark" :content="$route.query.type=='jpg'?'应用之后，自动生成白底图':'自动生成png透明背景图'" placement="bottom" v-if="isplugin">
            <div class="btn b-btn 
            " @click="use"> {{btntext}}</div>
        </el-tooltip>
    </div>
    <div class="firstupload" id="firstuploadbtn" v-if="!init">
        <div class="f_upload">上传图片</div>
        <p>上传一张图片，开始智能抠图！</p>
    </div>
</div>
</template>

<script>
import fileTypeChose from "./fileTypeChose";
export default {
    components: {
        fileTypeChose,
    },
    data() {
        return {
            hideDazeElement: false,
            drawflag: false,
            btntext: "完成抠图",
            isplugin: false,
            redoflag: false,
            zoom: 100,
            showwidth: "",
            showheight: "",
            canvasheight: "",
            canvaswidth: "",
            rate: 1,
            initX: "",
            initY: "",
            init: false,
            panactived: false,
            btnstatus: {
                back: true,
                forward: true,
            },
            info: {
                pngaddr: "",
                jpgaddr: "",
            },
            drawflag: false,
            imgHz: "",
        };
    },
    computed: {
        backstatus() {
            //监听后退状态改变样式
            if (this.init) {
                if (!this.btnstatus.back) {
                    return "notuse";
                }
            }
        },
        forwardstatus() {
            //监听前进状态改变样式
            if (this.init) {
                if (!this.btnstatus.forward) {
                    return "notuse";
                }
            }
        },
    },
    methods: {
        use() {
            let that = this;
            var tempaddr = "";
            if (!that.$store.state.info.jpgaddr && !that.$store.state.info.pngaddr) {
                var url = that.$route.query.imgsrc;
                var host = url.split("//")[0] + "//" + url.split("//")[1].split("/")[0];
                tempaddr = url.replace(host + "/", "");
            } else {
                if (that.$route.query.type == "jpg") {
                    tempaddr = that.$store.state.info.jpgaddr;
                    //  window.parent.postMessage(that.$store.state.info.jpgaddr, "*")
                } else {
                    tempaddr = that.$store.state.info.pngaddr;
                    //   window.parent.postMessage(that.$store.state.info.pngaddr, "*")
                }
            }

            that.$ajax
                .get(that.ajaxbaseurl + "/api/matting/getossdir", {
                    params: {
                        type: 1005,
                    },
                })
                .then(function(resData) {
                    that.$ajax
                        .post("https://api.fjdaze.com/oss/api/oss/transfer", {
                            ossDir: resData.data.result,
                            ossFilePath: tempaddr,
                        })
                        .then(function(res) {
                            if (res.data.Success) {
                                console.log(res.data.Data);
                                window.parent.postMessage(res.data.Data, "*");
                            }
                        });
                });
        },
        download(type) {
            if (!this.init) return;
            _hmt.push(["_trackEvent", "智能抠图", "·下载·点击"]);
            if (type == "png") {
                window.location.href =
                    "http://api.fjdaze.com/oss/api/oss/downloadfile?ossFilePath=" +
                    this.$store.state.info.pngaddr;
            } else {
                window.location.href =
                    "http://api.fjdaze.com/oss/api/oss/downloadfile?ossFilePath=" +
                    this.$store.state.info.jpgaddr;
            }
        },
        reupload() {
            //重新上传
            var temp = this.isplugin;
            Object.assign(this.$data, this.$options.data());
            this.isplugin = temp;
        },
        opentotalhelp() {
            //打开总帮助
            _hmt.push(["_trackEvent", "智能抠图", "·如何抠图·点击"]);
            this.$emit("opentotalhelp");
        },
        opennormalhelp() {
            //打开涂抹帮助
            this.$emit("opennormalhelp");
        },
        changebtnstatus(status) {
            //改变前进后退状态
            this.btnstatus = status;
        },
        tocare() {
            //开始精细抠图
            this.panactived = false;
            this.btnstatus.back = false;
            this.btnstatus.forward = false;
        },
        penactived() {
            //笔刷触发
            this.panactived = false;
        },
        firstinit() {
            //第一次初始化
            this.init = true;
        },
        tool(type) {
            //触发工具
            if (!this.init) {
                return;
            }
            switch (type) {
                case "back":
                    if (!this.btnstatus.back) {
                        return;
                    }
                    _hmt.push(["_trackEvent", "智能抠图", "·撤销·点击"]);
                    this.$emit("back");
                    break;
                case "forward":
                    if (!this.btnstatus.forward) {
                        return;
                    }
                    _hmt.push(["_trackEvent", "智能抠图", "·恢复·点击"]);
                    this.$emit("forward");
                    break;
                case "zoomin":
                    if (this.zoom == 400) {
                        return;
                    }
                    _hmt.push(["_trackEvent", "智能抠图", "·放大-·点击"]);
                    this.$emit("zoomin");
                    this.zoom += 20;
                    break;
                case "pan":
                    _hmt.push(["_trackEvent", "智能抠图", "·移动·点击"]);
                    this.$emit("pan");
                    this.panactived = true;
                    break;
                case "reset":
                    _hmt.push(["_trackEvent", "智能抠图", "·图片复位·点击"]);
                    this.zoom = 100;
                    this.$emit("reset");
                    break;
                case "zoomout":
                    if (this.zoom == 20) {
                        return;
                    }
                    _hmt.push(["_trackEvent", "智能抠图", "·缩小-·点击"]);
                    this.$emit("zoomout");
                    this.zoom -= 20;
                    break;
                case "redo":
                    _hmt.push(["_trackEvent", "智能抠图", "·重做-·点击"]);
                    this.$emit("redo");
                    this.reupload();
                    this.init = true;
                    break;
                default:
                    console.log("出错");
                    break;
            }
        },
        widoverhig() {
            this.showwidth = this.canvaswidth;
            this.showheight = this.canvaswidth * (this.imageheight / this.imagewidth);
            this.rate = this.imagewidth / this.canvaswidth;
        },
        higoverwid() {
            this.showheight = this.canvasheight;
            this.showwidth = this.canvasheight * (this.imagewidth / this.imageheight);
            this.rate = this.imageheight / this.canvasheight;
        },
        setimagesize(src) {
            let that = this;
            var image = new Image();
            image.src = src;
            image.onload = function() {
                that.imagewidth = image.width;
                that.imageheight = image.height;
                that.canvaswidth = document.body.scrollWidth / 2;
                that.canvasheight = parseInt(
                    document.getElementsByClassName("draw_part")[0].style.height
                );
                if (image.width < that.canvaswidth && image.height < that.canvasheight) {
                    that.showwidth = image.width;
                    that.showheight = image.height;
                } else {
                    if (image.width > that.canvaswidth && image.height > that.canvasheight) {
                        if (image.width / that.canvaswidth >= image.height / that.canvasheight) {
                            that.widoverhig();
                        } else {
                            that.higoverwid();
                        }
                    } else {
                        if (image.width > that.canvaswidth) {
                            that.widoverhig();
                        } else {
                            that.higoverwid();
                        }
                    }
                }
                that.initX = (that.canvaswidth - that.showwidth) / 2;
                that.initY = (that.canvasheight - that.showheight) / 2;
                that.info.canvaswidth = that.canvaswidth;
                that.info.canvasheight = that.canvasheight;
                that.info.showwidth = that.showwidth;
                that.info.showheight = that.showheight;
                that.info.initX = that.initX;
                that.info.initY = that.initY;
                that.info.rate = that.rate;
                that.info.hz = that.imgHz;

                that.$store.commit("setinfo", that.info);
                that.$emit("initcanvas");
                that.$emit("upload");
                if (localStorage.getItem("dzphnormalflag") === null) {
                    that.opennormalhelp();
                    localStorage.setItem("dzphnormalflag", true);
                }
            };
        },
        getImageResize(url) {
            return new Promise((resolve) => {
                const image = new Image();
                let hz = "";
                image.onload = () => {
                    if (image.width > 1600 && image.height > 1600) {
                        if (image.width >= image.height) {
                            hz = "?x-oss-process=image/resize,w_1600";
                        } else {
                            hz = "?x-oss-process=image/resize,h_1600";
                        }
                    } else if (image.width > 1600) {
                        hz = "?x-oss-process=image/resize,w_1600";
                    } else if (image.height > 1600) {
                        hz = "?x-oss-process=image/resize,h_1600";
                    }
                    this.imgHz = hz;
                    resolve(url + hz);
                };

                image.src = url;
            });
        },
    },
    async mounted() {
        let that = this;
        let { hideDazeElement = "false" } = this.$route.query;
        this.hideDazeElement = hideDazeElement == "false" ? false : true;
        document
            .getElementsByClassName("draw_part")[0]
            .addEventListener("DOMMouseScroll", wheel, false);
        document.getElementsByClassName("draw_part")[0].onmousewheel = wheel; //W3C

        function wheel(event) {
            var delta = 0;
            if (!event) event = window.event;
            if (event.wheelDelta) {
                delta = event.wheelDelta / 120;
                if (window.opera) delta = -delta;
            } else if (event.detail) {
                delta = -event.detail / 3;
            }
            if (delta) handle(delta);
        }

        function handle(delta) {
            if (delta < 0) {
                if (that.init) {
                    _hmt.push(["_trackEvent", "智能抠图", "·鼠标缩小·点击"]);
                }

                that.tool("zoomout");
            } else {
                //向上滚动
                if (that.init) {
                    _hmt.push(["_trackEvent", "智能抠图", "·鼠标放大·点击"]);
                }
                that.tool("zoomin");
            }
        }
        if (that.$route.query.btntext) {
            that.btntext = that.$route.query.btntext;
        }
        if (that.$route.query.imgsrc) {
            that.isplugin = true;
            that.$emit("upload");
            var url = that.$route.query.imgsrc;

            var host = url.split("//")[0] + "//" + url.split("//")[1].split("/")[0];
            var addr = url.replace(host + "/", "");
            that.info.host = host + "/";
            that.info.addr = addr;
            if (url.indexOf("x-oss-process") === -1) {
                //没有经过裁切的图片需要验证下图片大小
                url = await this.getImageResize(url);
            }

            that.setimagesize(url);
            return;
        }

        var uploader = new plupload.Uploader({
            browse_button: ["uploadbtn", "firstuploadbtn"], //触发文件选择对话框的按钮，为那个元素id
            url: "", //服务器端的上传页面地址
            max_file_size: "10mb", //限制为5mb
            filters: [
                {
                    title: "Image files",
                    extensions: "jpg,png,JPG,PNG,BMP,bmp,jpeg,JPEG",
                },
            ], //图片限制
            multipart_params: {},
        });

        //在实例对象上调用init()方法进行初始化
        uploader.init();
        uploader.bind("Error", function(uploader, errObject) {
            if (errObject.message == "File size error.") {
                that.$emit("error", "您上传的图片超过10M，请重新上传");
            } else {
                that.$emit("error", "上传时发生错误，请联系客服");
            }
        });
        //图片选择完毕触发
        uploader.bind("FilesAdded", function(uploader, files) {
            _hmt.push(["_trackEvent", "智能抠图", "·上传图片·点击"]);
            var imgdata = new FileReader();
            var file = files[0].getSource().getSource();
            imgdata.readAsDataURL(file);
            imgdata.onload = function() {
                var image = new Image();
                image.src = this.result;
                image.onload = function() {
                    if (image.width < 64 && image.height < 64) {
                        console.log(uploader);
                        uploader.removeFile(uploader.files[0].uid);
                        that.$emit("error", "上传失败,图片尺寸不能小于64x64");
                        return;
                    }
                    that.$emit("upload");
                    var targetfilenamearr = files[0].name.split(".");
                    var fussix = targetfilenamearr[targetfilenamearr.length - 1];
                    that.$ajax
                        .get(that.ajaxbaseurl + "/api/matting/getossdir", {
                            params: {
                                type: 1000,
                            },
                        })
                        .then(function(resData) {
                            that.$ajax
                                .get(
                                    (that.env == "dev"
                                        ? "https://api.fjdaze.com"
                                        : "https://api.fjdaze.com") + "/oss/api/oss/getsign",
                                    {
                                        params: {
                                            ossCallbackUrl:
                                                (that.env == "dev"
                                                    ? "https://api.fjdaze.com"
                                                    : "https://api.fjdaze.com") +
                                                "/oss/api/oss/imageuploadback",
                                            ossDir: resData.data.result,
                                        },
                                    }
                                )
                                .then(function(res) {
                                    if (!res.data.Success) {
                                        that.$emit("error", res.data.tips);
                                        return;
                                    }
                                    var resdata = res.data.Data;
                                    uploader.setOption({
                                        url: resdata.host,
                                        multipart_params: {
                                            Filename: resdata.filename,
                                            key: resdata.dir + resdata.filename + "." + fussix,
                                            policy: resdata.policy,
                                            OSSAccessKeyId: resdata.accessid,
                                            success_action_status: "200", //让服务端返回200，不设置则默认返回204
                                            signature: resdata.signature,
                                            callback: resdata.callback,
                                        },
                                    });
                                    that.info.host = resdata.host;
                                    that.info.addr = resdata.dir + resdata.filename + "." + fussix;
                                    uploader.start();
                                });
                        });
                };
            };
        });
        //图片上传成功触发，ps:data是返回值（第三个参数是返回值）
        uploader.bind("FileUploaded", function(uploader, files, data) {
            console.log(that.info.host + that.info.addr);
            that.setimagesize(that.info.host + that.info.addr);
        });

        document.addEventListener("keydown", function(event) {
            if (event.code === "KeyZ" && event.ctrlKey && event.shiftKey) {
                _hmt.push(["_trackEvent", "智能抠图", "·重做快捷键·点击"]);
                that.tool("redo");
            }
        });
    },
};
</script>

<style lang="scss" scoped>
.firstupload {
    position: fixed;
    z-index: 99;
    top: 50%;
    margin-top: -60px;
    left: 50%;
    margin-left: -112px;

    .f_upload {
        cursor: pointer;
        color: #fff;
        font-size: 24px;
        padding: 22px 63px;
        background: #0763fc;
    }

    p {
        font-size: 16px;
        color: #999;
        margin: 0;
        margin-top: 23px;
    }
}

.tabbar {
    height: 60px;
    background: #fff;
    box-shadow: 0px 1px 8px 0px rgba(213, 213, 213, 0.3);
    display: flex;
    align-items: center;
    overflow: initial;

    .tool {
        font-size: 18px;
        margin-right: 30px;
        color: #ccc;
    }

    .panactived {
        color: #333 !important;
    }

    .icon {
        padding-left: 23px;
        padding-right: 120px;
        width: 128px;
        .logo-text {
            font-size: 24px;
            font-weight: bold;
        }
    }

    .opera {
        flex: 1;
        display: flex;

        .zoom-num {
            color: #999;
            width: 39px;
            font-size: 16px;
            margin-right: 31px;
            text-align: center;
            padding-top: 2px;
        }

        .icon-pan {
            margin-right: 80px;
            position: relative;

            &::after {
                content: "";
                top: -7px;
                position: absolute;
                width: 1px;
                height: 30px;
                background: #e5e5e5;
                left: 56px;
            }
        }

        .icon-back {
            margin-right: 20px;
        }
    }

    .other-oprea {
        display: flex;

        .btn {
            height: 40px;
            line-height: 40px;
            padding: 0 24px;
            text-align: center;
            font-size: 16px;
            border-radius: 4px;
            margin-right: 20px;
            cursor: pointer;
        }

        .b-btn {
            background-color: #0763fc;
            color: #fff;
        }

        .upload {
            border-left: 1px solid #e5e5e5;
        }

        .download {
            background-color: #0763fc;
            color: #fff;
        }

        .help {
            padding-right: 40px;
            display: flex;
            align-items: center;
            cursor: pointer;
            line-height: 18px;
            font-size: 14px;
            color: #666;

            .icon-question {
                font-size: 18px;
                margin-right: 4px;
            }
        }

        .help:hover {
            i {
                color: #0763fc;
            }

            color: #0763fc;
        }
    }
}

.init {
    .tool {
        cursor: pointer;
        color: #666;
    }

    .tool:hover {
        color: #333;
    }

    .zoom-num {
        color: #666 !important;
    }
}

.notuse {
    color: #ccc !important;
    cursor: auto !important;
}
</style>
